import getThemeMerger from 'util/getThemeMerger'

export default getThemeMerger((currentTheme) => ({
  overrides: {
    MuiSvgIcon: {
      root: {
        fill: currentTheme.palette.tertiary.darkGreen,
      },
    },
  },
}))
